import BlSearchBarMv from './BlSearchBarMv.vue'

BlSearchBarMv.install = function (Vue) {
  Vue.component(BlSearchBarMv.name, BlSearchBarMv)
}

export default BlSearchBarMv
